/**
 * Texte localisé multi-locale (FR / EN / AR).
 *
 * Remplace le pattern `Record<Locale, string>` des dicos de contenu : `ar` est
 * OPTIONNEL pour permettre un déploiement INCRÉMENTAL de l'arabe (une page/silo
 * à la fois) sans casser la compilation ni le FR/EN. Quand `ar` manque, on
 * retombe sur le FR via `tr()`.
 *
 * - Config "toutes locales requises" (préfixes, hreflang, dir, labels switcher)
 *   garde `Record<Locale, X>` (on fournit toujours la valeur ar).
 * - Contenu (titres, descriptions, labels de page) utilise `I18n<X>` / `I18nText`.
 */
import type { Locale } from "@/config/i18n";

/** Dico localisé : fr/en requis (déjà présents partout), ar optionnel. */
export type I18n<T> = { fr: T; en: T; ar?: T };

/** Cas le plus fréquent : du texte. */
export type I18nText = I18n<string>;

/**
 * Lit la valeur d'un dico pour une locale, avec REPLI sur le FR si la locale
 * demandée (typiquement `ar` non encore traduit) est absente. Garantit un
 * retour défini (jamais `undefined`) car `fr` est toujours présent.
 */
export const tr = <T>(dict: I18n<T>, locale: Locale): T =>
  dict[locale] ?? dict.fr;
